import React from 'react';

import type { IconProps } from '~/components/icons/types';

import SvgIcon from '../core/SvgIcon';

/**
 * The conductor: ordered tracks with a marker on two of them.
 *
 * Added because nothing in the icon set reads as "an agent working a claim through ordered
 * stages" -- the nearest existing glyphs are either checkmarks or sort arrows, both of which say
 * something else. Follows the mock's glyph, and the folder's own convention (IconProps, an
 * `iconColor`-driven stroke, a default size).
 */
const ConductorIcon: React.FC<IconProps> = ({ iconColor, size = 24, ...props }) => (
  <SvgIcon viewBox="0 0 24 24" fill="none" iconColor={iconColor} size={size} {...props}>
    <path
      d="M4 6h10M4 12h16M4 18h7"
      stroke={iconColor}
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="18" cy="6" r="2" stroke={iconColor} strokeWidth="1.6" />
    <circle cx="14" cy="18" r="2" stroke={iconColor} strokeWidth="1.6" />
  </SvgIcon>
);

export default ConductorIcon;
